module.exports = __webpack_public_path__ + "static/media/download-circle.03c3ae3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-circle.svg
// module id = 293
// module chunks = 0